// @flow

import * as React from 'react';
import s from './ButtonTab.scss';

type Props = {
  label: string,
  onClick: () => void,
  disabled: boolean,
  selected: boolean,
  size: string, // large, medium, small
}

export const ButtonTab = (props: Props) => {
  const { label, disabled, onClick, size, selected } = props;
  let classes = [];
  const sizeGiven = size && ['large', 'medium', 'small'].indexOf(size.toLowerCase()) !== -1;
  if (sizeGiven) {
    classes.push(s[size]);
  }
  if (selected) {
    classes.push(s.selected);
  }

  return (
    <button
      className={classes.join(' ')}
      onClick={() => onClick()}
      disabled={disabled}
    >
      {label}
    </button>
  )
}

export default ButtonTab;
